import type { JSX } from 'react/jsx-runtime'
import {type combineType, type RenderComponentIprops, YoBtnType, YoComponentType} from 'src/biz/types'
import type {SelectProps} from 'src/ui'
import {Button, ConfigProvider, DatePicker, Input, Radio, Select} from 'src/ui'

export const RenderMapComp: Record<combineType, (T: RenderComponentIprops) => JSX.Element> = {
  [YoComponentType.Input]: (props: RenderComponentIprops) => {
    return <Input {...props} />
  },
  [YoComponentType.Select]: (props: RenderComponentIprops & SelectProps) => {
    const {valueText = '', ...params}: any = props
    return <Select {...params} />
  },
  [YoComponentType.BaseText]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    return <span>{valueText}</span>
  },
  [YoComponentType.Radio]: (props: RenderComponentIprops) => {
    const {value, ...resetProps} = props
    return <Radio.Group value={value} {...resetProps} />
  },
  [YoBtnType.ButtonAdd]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    return (
      <Button {...params} type="primary">
        {props.label}
      </Button>
    )
  },
  [YoComponentType.RangePicker]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    const {RangePicker} = DatePicker
    const {locale, ...restParams} = params
    return <RangePicker {...restParams} />
  },
  [YoComponentType.DatePicker]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    return <DatePicker {...params} />
  },
  [YoBtnType.ButtonSearch]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    return (
      <Button {...params} type="primary">
        {props.label}
      </Button>
    )
  },
  [YoBtnType.ButtonNormal]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    return (
      <Button {...params} type="primary">
        {props.label}
      </Button>
    )
  },
  [YoBtnType.ButtonReset]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    return (
      <Button {...params} type="primary">
        {props.label}
      </Button>
    )
  },
  [YoBtnType.ButtonExport]: (props: RenderComponentIprops) => {
    const {valueText = '', ...params} = props
    return (
      <Button {...params} type="primary">
        {props.label}
      </Button>
    )
  },
  [YoComponentType.Render]: (props: RenderComponentIprops): JSX.Element => {
    const {valueText = '', ...params} = props
    const {render, ...rest} = props
    const RenderComp =
      typeof render === 'function' && render ? render(rest) : render ? <>{render}</> : <>未配置自定义render组件</>
    return RenderComp
  },
  [YoComponentType.LabelInput]: (props: RenderComponentIprops) => {
    const {type, valueText = '', ...params} = props
    return <>未配置{type}组件</>
  },
  [YoBtnType.ButtonDelete]: (props: RenderComponentIprops) => {
    const {type, valueText = '', ...params} = props
    return <>未配置{type}组件</>
  },
  [YoBtnType.ButtonEdit]: (props: RenderComponentIprops) => {
    const {type, valueText = '', ...params} = props
    return <>未配置{type}组件</>
  },
} as const
export const RenderComponent: React.FC<RenderComponentIprops> = props => RenderMapComp[props.type](props)
